import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

searchBoxStyles.search = {
    iconProps: { src: Search },
    cssOverrides: {
        formInputWrapper: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        width: 300px;
                    `,
                    css`
                        width: 300px;
                    `,
                ])}
        `,
        inputSelect: css`
            border-radius: 40px;
        `,
    },
};
